<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="USUÁRIOS" page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/team.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/usuarios']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button *ngIf="podeIncluir() && entidade.solicitacao" type="button" data-toggle="modal"
            data-target="#dialogAutorizar" class="btn btn-danger float-right mr-2" style="font-size: 13px">
            <img src="assets/img/global/lock_go.png" alt="autorizar" class="mr-2" title="Autorizar" height="18"
              width="18">Autorizar
          </button>
          <button *ngIf="podeIncluir()" type="submit" (click)="submitForm()"
            class="btn btn-outline-info float-right mr-5" style="font-size: 13px">Salvar</button>
        </div>
      </div>
      <hr class="mt-0 mb-2" />
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="dados-usuario-tab" data-toggle="tab" href="#dados-usuario" role="tab"
            aria-controls="dados-usuario" aria-selected="true">Dados do Usuário</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="permissao-tab" data-toggle="tab" href="#permissao" role="tab"
            aria-controls="permissao" aria-selected="false">Permissões</a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane fade show active" id="dados-usuario" role="tabpanel" aria-labelledby="dados-usuario-tab">
          <div class="row pt-3">
            <div class="col-md-8">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="nome">Nome<span class="text-danger">*</span></label>
                  <input formControlName="nome" type="text" class="form-control" id="nome">
                </div>
                <div class="form-group col-md-6">
                  <label for="sobrenome">Sobrenome<span class="text-danger">*</span></label>
                  <input formControlName="sobrenome" type="text" class="form-control" id="sobrenome">
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="row">
                <div class="form-group col-12">
                  <div class="checkbox checbox-switch switch-primary">
                    <label>
                      <input formControlName="administrador" type="checkbox" (click)="verificaCheck()" />
                      <span></span>
                      Administrador do sistema
                    </label>
                  </div>
                  <div *ngIf="entidadeForm.get('sistema').value === 'controle-interno'"
                    class="checkbox checbox-switch switch-secondary">
                    <label>
                      <input formControlName="convidado" type="checkbox" (click)="verificaCheck()" />
                      <span></span>
                      Usuário convidado
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="cpf">CPF<span class="text-danger">*</span></label>
                  <input [imask]="{mask: '000.000.000-00'}" unmask="true" formControlName="cpf" type="text"
                    class="form-control" id="cpf">
                </div>
                <div class="form-group col-md-4">
                  <label for="telefone">Telefone<span class="text-danger">*</span></label>
                  <input
                    [imask]="{mask: [ {mask: '0000-0000'}, {mask: '00000-0000'}, {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}"
                    unmask="true" formControlName="telefone" type="text" class="form-control" id="telefone">
                </div>
                <div class="form-group col-md-4">
                  <label for="email">E-mail<span class="text-danger">*</span></label>
                  <input formControlName="email" type="text" class="form-control font-weight-bold" id="email"
                    style="color: #1565c0">
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-3 mb-2" />
          <div *ngIf="entidadeForm.get('administrador').value" class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="sistema">Sistema Principal<span class="text-danger">*</span></label>
                  <select formControlName="sistema" name="sistema" id="sistema" class="form-control custom-select">
                    <option [ngValue]="item.id" *ngFor="let item of listaSistemas">
                      {{globalService.traduzirSistema(item.id)}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="horario_inicio">Horário de acesso<span class="text-danger">*</span></label>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <input [imask]="{mask: '00:00'}" [unmask]="false" formControlName="horario_inicio"
                        [ngClass]="{ 'is-invalid': f.submitted }" required type="text" class="form-control"
                        name="horario_inicio" placeholder="Início" id="horario_inicio">
                    </div>
                    <div class="form-group col-md-6">
                      <input [imask]="{mask: '00:00'}" [unmask]="false" formControlName="horario_termino"
                        [ngClass]="{ 'is-invalid': f.submitted }" required type="text" class="form-control"
                        name="horario_termino" placeholder="Término" id="horario_termino">
                    </div>
                  </div>
                </div>
                <div class="form-group pt-4 col-md-4">
                  <div class="checkbox checbox-switch switch-primary form-check-inline">
                    <label>
                      <input formControlName="sabado" type="checkbox" />
                      <span></span>
                      Sábado
                    </label>
                  </div>
                  <div class="checkbox checbox-switch switch-primary form-check-inline">
                    <label>
                      <input formControlName="domingo" type="checkbox" />
                      <span></span>
                      Domingo
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6" *ngIf="entidadeForm.get('sistema').value === 'portal-entidade'">
              <label for="favorecido">Entidade</label>
              <p-autoComplete id="favorecido" formControlName="favorecido" field="nome"
                [suggestions]="favorecidoAutoComplete.lista" (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                placeholder="Informe a entidade" inputStyleClass="form-control" minLength="2"
                [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true">
              </p-autoComplete>
            </div>
            <div class="form-group col-md-6" *ngIf="entidadeForm.get('sistema').value === 'terceiro-setor'">
              <label for="unidade">Unidade administrativa</label>
              <p-autoComplete id="unidade" formControlName="unidade" field="nome"
                [suggestions]="unidadeAutoComplete.lista" (completeMethod)="unidadeAutoComplete.filtrar($event)"
                placeholder="Informe o código ou nome unidade" inputStyleClass="form-control" minLength="2"
                [style]="{ width: '100%' }" [forceSelection]="true" [dropdown]="true" [autoHighlight]="true"
                aria-describedby="unidadeHelp">
              </p-autoComplete>
              <small id="unidadeHelp" class="form-text text-muted">Informe para usuários que trabalham nas unidades
                administrativas.</small>
            </div>
          </div>
          <div class="row" *ngIf="entidadeForm.get('sistema').value !== 'portal-entidade'">
            <div class="form-group col-md-6">
              <div class="row">
                <div class="col-12">
                  <label for="estoque">Estoque Principal/Secundários</label>
                  <p-autoComplete id="estoque" formControlName="estoque" field="nome"
                    [suggestions]="estoqueAutoComplete.lista" (completeMethod)="estoqueAutoComplete.filtrar($event)"
                    placeholder="Informe o estoque" inputStyleClass="form-control" minLength="2"
                    [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true">
                  </p-autoComplete>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <p-autoComplete [(ngModel)]="estoqueAtual" [ngModelOptions]="{standalone: true}" field="nome"
                    [suggestions]="estoqueAutoComplete.lista" (completeMethod)="estoqueAutoComplete.filtrar($event)"
                    placeholder="Selecione o Estoque para adicionar" inputStyleClass="form-control" minLength="2"
                    [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    (onSelect)="adicionarUsuarioEstoque()">
                  </p-autoComplete>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center p-2"
                      *ngFor="let item of entidade.usuario_estoques; let idx = index">
                      {{item.estoque?.nome}}
                      <a class="btn btn-sm badge" (click)="removerUsuarioEstoque(item, idx)">
                        <i class="fa fa-times"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="row">
                <div class="col-12">
                  <label for="setor">Setor Principal/Secundários</label>
                  <p-autoComplete id="setor" formControlName="setor" field="nome"
                    [suggestions]="setorAutoComplete.lista" (completeMethod)="setorAutoComplete.filtrar($event)"
                    placeholder="Informe o setor" inputStyleClass="form-control" minLength="2"
                    [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true">
                  </p-autoComplete>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <p-autoComplete [(ngModel)]="setorAtual" [ngModelOptions]="{standalone: true}" field="nome"
                    [suggestions]="setorAutoComplete.lista" (completeMethod)="setorAutoComplete.filtrar($event)"
                    placeholder="Selecione o Setor para adicionar" inputStyleClass="form-control" minLength="2"
                    [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    (onSelect)="adicionarUsuarioSetor()">
                  </p-autoComplete>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center p-2"
                      *ngFor="let item of entidade.usuario_setores; let idx = index">
                      {{item.setor?.nome}}
                      <a class="btn btn-sm badge" (click)="removerUsuarioSetor(item, idx)">
                        <i class="fa fa-times"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="permissao" role="tabpanel" aria-labelledby="permissao-tab">
          <div *ngIf="!entidadeForm.get('convidado').value">
            <br />
            <div class="row">
              <div class="col-12 float-right">
                <button type="button" data-toggle="modal" data-target="#dialogImportar" (click)="carregarUsuariosCC()"
                  class="btn btn-sm btn-link float-right">
                  <img src="assets/img/global/text_imports.png" alt="cvs" height="16" width="16">
                  Importar Permissões
                </button>
              </div>
            </div>
            <p-tabView orientation="left" styleClass="form-row tabela-permissoes">
              <p-tabPanel [header]="globalService.traduzirSistema(acesso.sistema)" *ngFor="let acesso of acessos"
                [selected]="acesso.sistema === entidade.sistema">
                <div class="row mb-4"
                  *ngIf="entidadeForm.get('administrador').value && acesso.sistema === entidadeForm.get('sistema').value">
                  <div class="col-12">
                    <img src="assets/img/global/warning.png" alt="cvs" height="16" width="16">
                    Este usuário é administrador deste sistema, logo as permissões abaixo são ignoradas.
                  </div>
                </div>
                <div class="float-left col-6 p-0" *ngFor="let item of acesso.acessos">
                  <div class="form-row small">
                    <div class="col-auto">
                      <p-selectButton [options]="opcoesAcesso" [(ngModel)]="item.permissao"
                        [ngModelOptions]="{standalone: true}" [ngStyle]="{width: '100%'}">
                        <ng-template let-item>
                          <div style="padding: .25em .5em">
                            <img style="vertical-align: middle" src="assets/img/global/{{item.icon}}" height="16px"
                              title="{{item.label}}" />
                          </div>
                        </ng-template>
                      </p-selectButton>
                    </div>
                    <div class="col-8">
                      <label style="padding-top: 3px">
                        {{item.nomePagina}}
                      </label>
                    </div>
                  </div>
                </div>
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
      </div>
      <!-- <pre>{{ acessos | json}}</pre> -->
    </form>
  </div>
</div>

<div class="modal fade" id="dialogAutorizar" tabindex="-1" role="dialog" aria-labelledby="autorizacao"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Autorização de acesso</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row">
            <div class="col-12">
              <img src="assets/img/global/user-email.png" alt="email">
              <span class="float-right">Um e-mail com a autorização será encaminhado ao usuário.</span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <span class="font-weight-bold">{{entidade.nome}} {{entidade.sobrenome}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <span class="font-weight-bold">{{entidade.email}}</span>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button (click)="autorizar()" type="button" class="btn btn-primary btn-sm" id="btnAutorizar"
          data-dismiss="modal">Enviar</button>
        <button type="button" class="btn btn-link" id="btnCancelarUpload" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogImportar" tabindex="-1" role="dialog" aria-labelledby="importar" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Importar permissões</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row">
            <div class="col-12">
              <select [(ngModel)]="acessosCC" [ngModelOptions]="{standalone: true}" class="form-control custom-select">
                <option [ngValue]="item.acessos" *ngFor="let item of listaUsuariosCC">
                  {{item.nome}}
                </option>
              </select>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button (click)="importarPermissoes()" type="button" class="btn btn-primary btn-sm" id="btnImportar"
          data-dismiss="modal">Importar</button>
        <button type="button" class="btn btn-link" id="btnCancelarImportart" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>